import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { AddressModel } from './address.model';

export class Place {
  constructor(
    public id:string,
    public name:string = "",
    public description: string,
    public address: AddressModel
  ){}
}

@Injectable({
  providedIn: 'root'
})
export class PlaceAdapter implements Adapter<Place> {
  adapt(item: any): Place {
    return new Place(
      item.id,
      item.name,
      item.description,
      item.address
    );
  }
}
